
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/signin",
      function () {
        return require("private-next-pages/company/signin/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/signin"])
      });
    }
  